<template>
	<v-container id="regular-tables-view" fluid tag="section" class="mobile">
		<material-card icon="mdi-clipboard-text" icon-small title="تعریف وام ها" color="accent">
			<template v-slot:beforeBody>
				<div class="text-left mb-4 px-5">
					<v-btn color="primary" dark class="mx-1" @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن وام
					</v-btn>
				</div>
			</template>
			<div class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
				</v-row>
				<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :loading="loading" :items="loans" :search="search" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" class="elevation-1">
					<template v-slot:item.title="{ item }">
						<div>{{ item.title }}</div>
						<div class="grey--text d-flex flex-wrap" style="column-gap: 20px">
							<div>
								<small>نوع بهره:</small> <small>{{ item.loanProfitType === 0 ? 'سود ماهانه' : 'سود بانکی' }}</small>
							</div>
							<div>
								<small>درصد بهره:</small> <small>{{ item.profitPercent }}</small>
							</div>
							<div>
								<small>درصد دیرکرد:</small> <small>{{ item.delayPercent }}</small>
							</div>
							<div>
								<small>درصد زودکرد:</small> <small>{{ item.earlyPercent }}</small>
							</div>
						</div>

					</template>
					<!-- <template v-slot:item.isSponsored="{ item }">
						{{ item.isSponsored ? 'بلی' : 'خیر' }}
					</template> -->
					<template v-slot:item.loanProfitType="{ item }">
						{{ item.loanProfitType === 0 ? 'سود ماهانه' : 'سود بانکی' }}
					</template>
					<template v-slot:item.isSmsActive="{ item }">
						<div class="grey--text d-flex flex-column py-2" style="">
							<div class="d-flex">
								<small :class="item.isSmsActive ? 'success--text ml-1' : 'grey--text ml-1'">پیامک های یادآوری:</small>
								<v-icon v-if="item.isSmsActive" color="success" title="فعال" size="16">
									mdi-check-circle
								</v-icon>
								<v-icon v-else color="#aaa" title="غیر فعال" size="16">
									mdi-close-circle
								</v-icon>
							</div>
							<div class="d-flex">
								<small :class="item.hasSponsore ? 'red--text ml-1' : 'success--text ml-1'">نمایش در لیست معوق ها:</small>
								<v-icon v-if="item.hasSponsore" color="red" title="عدم نمایش" size="16">
									mdi-close-circle
								</v-icon>
								<v-icon v-else color="success" title="نمایش" size="16">
									mdi-check-circle
								</v-icon>
							</div>
							<div class="d-flex">
								<small :class="item.disable ? 'red--text ml-1' : 'success--text ml-1'">وضعیت وام: {{ item.disable ? 'غیر فعال' : 'فعال' }}</small>
								<v-icon v-if="item.disable" color="red" title="غیرفعال" size="16">
									mdi-close-circle
								</v-icon>
								<v-icon v-else color="success" title="فعال" size="16">
									mdi-check-circle
								</v-icon>
							</div>
						</div>
					</template>
					<template v-slot:item.operations="{ item }">
						<v-btn class="mx-2" fab dark small color="secondary" @click="edit(item)">
							<v-icon dark>
								mdi-square-edit-outline
							</v-icon>
						</v-btn>
						<v-btn class="mx-2" fab dark small color="pink" @click="remove(item)">
							<v-icon dark>
								mdi-trash-can-outline
							</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</div>
			<v-dialog v-model="dialog" scrollable persistent max-width="800px">
				<v-card>
					<v-card-title>
						<span class="headline">اطلاعات وام</span>
						<v-spacer />
						<v-btn @click="dialog = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-tabs v-model="activeTab" background-color="transparent" centered color="secondary" slider-color="secondary">
								<v-tab :value="0">مشخصات وام</v-tab>
								<v-tab :value="1" v-show="checkActivePart('loanExtraTabs')">اطلاعات طرح</v-tab>
								<v-tab :value="2" v-show="checkActivePart('loanExtraTabs')">مدارک لازم</v-tab>
								<v-tab :value="3" v-show="checkActivePart('agent')">مدارک لازم نماینده</v-tab>
								<v-tab :value="4" v-show="checkActivePart('contact')">سهم طرف حساب ها</v-tab>
								<v-tab :value="5">شرایط متقاضی</v-tab>

								<v-tabs-items v-model="activeTab" touchless class="mt-4 mx-auto" style="max-width: 550px;">
									<v-tab-item :key="0">
										<v-form ref="form1" class="mx-2" lazy-validation>
											<v-row>
												<!-- <v-col cols="12" md="3">
													<v-text-field ref="code" v-model="localData.code" label="کد وام*" :error-messages="errorMessages" :rules="[() => !!localData.code && localData.code != 0 || 'شماره وام را وارد کنید']" required />
												</v-col> -->
												<v-col cols="12" md="12">
													<v-text-field ref="title" v-model="localData.title" label="عنوان*" :error-messages="errorMessages" :rules="[() => !!localData.title || 'عنوان وام را وارد کنید']" required />
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="12" md="6">
													<v-select label="نحوه محاسبه سود" :items="profitTypes" item-text="title" item-value="value" v-model="localData.loanProfitType"></v-select>
													<!-- <v-radio-group compact v-model="allowedInstallments.selectedRadio" row>
														<v-radio compact label="سود ماهانه" color="secondary" :value="0"></v-radio>
														<v-radio compact label="سود بانکی" color="secondary" :value="1"></v-radio>
													</v-radio-group> -->
												</v-col>
												<v-col cols="12" md="6">
													<v-text-field ref="profitPercent" type="number" v-model="localData.profitPercent" label="درصد بهره*" :error-messages="errorMessages" :rules="[() => localData.profitPercent >= 0 || 'درصد بهره را وارد کنید']" required />
												</v-col>
												<v-col cols="12" md="6">
													<v-text-field ref="delayPercent" type="number" v-model="localData.delayPercent" label="ضریب دیرکرد روزانه (مثلا 0.0008)*" :error-messages="errorMessages" :rules="[() => localData.delayPercent >= 0 || 'درصد دیرکرد را وارد کنید']" required />
												</v-col>
												<v-col cols="12" md="6">
													<v-text-field ref="earlyPercent" type="number" v-model="localData.earlyPercent" label="ضریب زودکرد روزانه (مثلا 0.0008)*" :error-messages="errorMessages" :rules="[() => localData.earlyPercent >= 0 || 'درصد زودکرد را وارد کنید']" required />
												</v-col>
												<v-col cols="12" md="6">
													<v-text-money v-model="localData.maxAmount" persistent-hint label="سقف مبلغ وام" :error-messages="errorMessages" :rules="[() => !localData.maxAmount || localData.maxAmount > 0 || 'سقف مبلغ وام را به صورت صحیح وارد کنید']" />
												</v-col>
												<v-col cols="12" md="6">
													<v-text-field type="number" max="10" persistent-hint v-model="localData.maxMonthGap" label="حداکثر فاصله بین اقساط" :error-messages="errorMessages" :rules="[() => localData.maxMonthGap >= 0 || 'حداکثر فاصله بین اقساط نمی تواند کمتر از 0 باشد']" />
												</v-col>
												<v-col cols="12" md="12">
													<div class="">
														<div>
															دوره های بازپرداخت مجاز:
														</div>
														<div class="pr-3">
															<v-radio-group compact v-model="allowedInstallments.selectedRadio" column>
																<v-radio compact label="بدون محدودیت" color="secondary" :value="0"></v-radio>
																<div class="d-flex">
																	<v-radio compact label="حداکثر تا" color="secondary" :value="1"></v-radio>
																	<v-text-field v-show="allowedInstallments.selectedRadio === 1" class="center-input py-0 mb-0 mr-2 ml-2" style="max-width:75px;margin-top:-10px;" type="number" compact hide-details v-model="allowedInstallments.max" label="" :error-messages="errorMessages" :rules="[(val) => allowedInstallments.selectedRadio !== 1 || val >= 0 || 'حداکثر تعداد ماه را وارد کنید']" required />
																	<span class="grey--text" v-show="allowedInstallments.selectedRadio === 1">ماه</span>
																</div>
																<div class="d-flex">
																	<v-radio style="min-width: 170px;" compact label="تعیین ماه های مجاز" color="secondary" :value="2"></v-radio>
																	<div class="d-flex flex-wrap mr-2" v-if="allowedInstallments.selectedRadio === 2">
																		<div v-for="(ins, index) in allowedInstallments.splitedInstallments.filter(x => x.status !== 'new')" :key="ins.value" style="padding: 5px;border-radius: 10px;background: #e7e7e7;display: flex;margin-left: 5px">
																			<small>{{ ins.value }} ماه</small>
																			<small v-if="ins.max" class="mr-1">(سقف {{ String(ins.max).toPriceFormat() }})</small>
																			<v-btn color="red" x-small icon @click="removeAllowedInstallmentsItem(index)">
																				<v-icon>mdi-close</v-icon>
																			</v-btn>
																		</div>
																		<div v-for="(ins, index) in allowedInstallments.splitedInstallments.filter(x => x.status === 'new')" :key="index" style="display: flex;border:1px solid #ddd; border-radius: 5px;margin-left: 5px;padding:10px 3px">
																			<small class="grey--text mx-2">ماه</small>
																			<v-text-field type="number" v-model="ins.value" label="" compact hide-details class="center-input py-0 mb-0" style="max-width: 40px;margin-top:-10px" />
																			<small class="grey--text mx-2">سقف</small>
																			<v-text-money v-model="ins.max" label="" compact hide-details class="center-input py-0 mb-0" style="width: 95px;margin-top:-10px" />
																			<v-btn color="red" x-small icon @click="() => { allowedInstallments.splitedInstallments.splice(allowedInstallments.splitedInstallments.findIndex(x => x.key === ins.key), 1) }">
																				<v-icon>mdi-close</v-icon>
																			</v-btn>
																			<v-btn color="success" x-small icon @click="() => ins.status = ''">
																				<v-icon>mdi-check</v-icon>
																			</v-btn>
																		</div>
																		<v-btn color="success" x-small class="mt-1" @click="addAllowedInstallmentsItem">
																			<v-icon>mdi-plus</v-icon>
																		</v-btn>
																	</div>
																</div>
															</v-radio-group>
														</div>
													</div>
												</v-col>
												<v-col cols="12" md="12">
													<div>
														<v-checkbox v-if="showSponsoreCheck" color="secondary" compact class="py-0 my-0" v-model="localData.isSponsored" label="اسپانسر این نوع وام هستم." />
													</div>
													<div>
														<v-checkbox color="secondary" compact class="py-0 my-0" v-model="localData.isSmsActive" label="پیامک و ایمیل های یادآوری این نوع وام فعال باشد." />
													</div>
													<div>
														<v-checkbox color="secondary" compact class="py-0 my-0" v-model="localData.hasSponsore" label="پیگیری وصول با اسپانسر بوده و در لیست معوق ها نمایش داده نشود." />
														<v-text-field v-show="localData.hasSponsore" type="number" class="py-0 mb-0" style="max-width:300px" compact v-model="localData.defaultSponsoreCheckoutDays" label="تعداد روز پیش فرض تسویه توسط اسپانسر:" :error-messages="errorMessages" />
													</div>
													<div>
														<v-checkbox color="secondary" compact class="py-0 my-0" v-model="localData.disable" label="ثبت و درخواست این نوع وام تا اطلاع ثانوی غیرفعال باشد." />
														<v-text-field v-show="localData.disable" class="py-0 mb-0" style="" compact v-model="localData.disableText" label="متن غیرفعال بودن جهت اطلاع کاربر:" :error-messages="errorMessages" />
													</div>
												</v-col>
											</v-row>
											<small>*فیلدهای ستاره دار ضروری هستند.</small>
										</v-form>
									</v-tab-item>
									<v-tab-item :key="1">
										<v-form ref="form2" class="mx-2" lazy-validation>
											<v-row class="">
												<v-col cols="12" md="12" class="d-flex justify-center py-5">
													<v-switch v-model="localData.includePlan" @change="changeIncludePlanSwitch" label="وام در لیست طرح ها قرار بگیرد؟" color="secondary" :value="true" hide-details></v-switch>
												</v-col>
											</v-row>
											<v-row v-if="localData.includePlan">
												<v-col cols="12" md="12" class="text-center">
													<ImageUploader ref="imageUploader" v-model="localData.base64" :editable="true" :options="imageUploaderOptions" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.base64)" @delete="() => localData.fileName = ''" />
													<!-- <v-icon style="cursor: pointer;" class="mx-auto" @click="viewImage(localData.base64)" fab color="green">mdi-magnify-plus</v-icon> -->
												</v-col>
												<v-col cols="12" md="12">
													<v-text-field v-model="localData.planTitle" outlined label="عنوان طرح" :error-messages="errorMessages" :rules="[() => !localData.includePlan || localData.includePlan && !!localData.planTitle || 'عنوان طرح را وارد کنید']" />
												</v-col>
												<v-col cols="12" md="12">
													<div class="d-flex justify-space-between mb-2">
														<small>برچسب ها:</small>
														<small class="blue--text pointer" @click="tagsDialog = true">
															مدیریت لیست برچسب ها
														</small>
													</div>
													<v-select label="" multiple :items="tags" return-object outlined item-text="title" item-value="id" v-model="localData.tags"></v-select>
												</v-col>

												<v-col cols="12" md="12">
													<v-textarea v-model="localData.planShortDescription" outlined :error-messages="errorMessages" label="توضیحات کوتاه طرح" hint="حداکثر 1000 کاراکتر" />
												</v-col>

												<v-col cols="12" md="12">
													<label>توضیحات کامل طرح:</label>
													<ckeditor :editor="editor" v-model="localData.planHtml" :config="editorConfig" @ready="onEditorReady"></ckeditor>
												</v-col>

												<v-col cols="12" md="12">
													<v-card elevation="3" color="#eee" class="pa-3">
														<label>هزینه های عملیاتی:</label>
														<div>
															<small>در صورتیکه می خواهید درصد کسری برای همه نوع ماه بازپرداخت در نظر گرفته شود، فیلد
																بازپرداخت را خالی بگذارید.</small>
														</div>
														<v-row class="d-flex my-3" v-for="(cost, index) in loanCosts" :key="index">
															<v-col cols="12" md="3" class="py-0 px-0 pl-1">
																<v-text-field v-model="cost.title" compact outlined label="عنوان هزینه" :error-messages="errorMessages" :rules="[(value) => !!value || 'عنوان هزینه را وارد کنید']" />
															</v-col>
															<v-col cols="12" md="4" class="py-0 px-0 pl-1">
																<v-text-field v-model="cost.month" compact type="number" outlined label="دوره بازپرداخت (ماه)" :error-messages="errorMessages" />
															</v-col>
															<v-col cols="12" md="2" class="py-0 px-0 pl-1">
																<v-text-field v-model="cost.gap" compact type="number" outlined label="فاصله" :error-messages="errorMessages" />
															</v-col>
															<v-col cols="12" md="2" class="py-0 px-0 pl-1">
																<v-text-field v-model="cost.amount" compact type="number" outlined label="درصد کسری" :error-messages="errorMessages" :rules="[(value) => !!value || 'درصد هزینه را وارد کنید']" />
															</v-col>
															<v-col cols="12" md="1" class="d-flex justify-center align-center py-0">
																<v-btn @click="removeCost(index)" class="" small icon dark title="حذف">
																	<v-icon dark color="red">
																		mdi-close
																	</v-icon>
																</v-btn>
															</v-col>
														</v-row>
														<div class="text-center pa-3">
															<v-btn @click="addCost()" color="secondary" small dark title="افزودن">
																<v-icon>
																	mdi-plus
																</v-icon>
															</v-btn>
														</div>
													</v-card>
												</v-col>

											</v-row>
										</v-form>
									</v-tab-item>
									<v-tab-item :key="2" class="pa-5">
										<v-alert v-if="isNew" icon="mdi-shield-lock-outline" type="warning" outlined>
											جهت ثبت مدارک، ابتدا فرم را ذخیره کنید.
										</v-alert>
										<LoanAuthorizationItems v-else-if="dialog" :data="localData" />
									</v-tab-item>
									<v-tab-item :key="3" class="pa-5">
										<v-alert v-if="isNew" icon="mdi-shield-lock-outline" type="warning" outlined>
											جهت ثبت مدارک، ابتدا فرم را ذخیره کنید.
										</v-alert>
										<AgentLoanAuthorizationItems v-else-if="dialog" :data="localData" />
									</v-tab-item>
									<v-tab-item :key="4" class="pa-5">
										<v-alert v-if="isNew" icon="mdi-shield-lock-outline" type="warning" outlined>
											جهت ثبت سهم طرف حساب ها، ابتدا فرم را ذخیره کنید.
										</v-alert>
										<LoanContacts v-else-if="dialog" :data="localData" />
									</v-tab-item>
									<v-tab-item :key="5" class="pa-5">
										<v-alert v-if="!checkActivePart('assuranceRequirement')" icon="mdi-shield-lock-outline" type="warning" outlined>
											ماژول شرایط مشتری برای شما فعال نمی باشد.
										</v-alert>
										<div v-else>
											<v-alert v-if="isNew" icon="mdi-shield-lock-outline" type="warning" outlined>
												جهت ثبت ضامن های مورد نیاز، ابتدا فرم را ذخیره کنید.
											</v-alert>
											<LoanAssuranceRequirements v-else-if="dialog" :data="localData" />
										</div>
									</v-tab-item>
								</v-tabs-items>
							</v-tabs>
						</v-container>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer />
						<v-btn @click="dialog = false">
							بستن
						</v-btn>
						<v-btn color="blue" dark @click="submit" :loading="submitLoading">
							ذخیره
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="tagsDialog" scrollable max-width="700px">
				<Tags v-if="tagsDialog" @callbck="loadTags()" @close="tagsDialog = false" :category="0" />
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import { get } from 'vuex-pathify'
	import { emptyId } from '@/util/emptyId'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document'
	// import { Bold, Italic } from '@ckeditor/ckeditor5-basic-styles'

	export default {
		name: 'RegularTablesView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			LoanAuthorizationItems: () => import('@/components/forms/LoanAuthorizationItems.vue'),
			AgentLoanAuthorizationItems: () => import('@/components/forms/AgentLoanAuthorizationItems.vue'),
			LoanAssuranceRequirements: () => import('@/components/forms/LoanAssuranceRequirements.vue'),
			LoanContacts: () => import('@/components/forms/LoanContacts.vue'),
			Tags: () => import('@/components/forms/Tags.vue'),
			ImageUploader,
		},
		data() {
			return {
				profitTypes: [{ title: 'سود ماهانه', value: 0 }, { title: 'سود بانکی', value: 1 }],
				search: '',
				loading: false,
				submitLoading: false,
				activeTab: 0,
				overlayImgSrc: '',
				overlay: false,
				errorMessages: '',
				localData: {},
				selectedItem: null,
				dialog: false,
				tagsDialog: false,
				headers: [
					{
						text: 'شماره',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 75
					}, {
						text: 'عنوان',
						align: 'start',
						sortable: true,
						value: 'title',
						// width: 500
					},
					// {
					// 	text: 'درصد بهره',
					// 	align: 'center',
					// 	sortable: true,
					// 	value: 'profitPercent',
					// }, {
					// 	text: 'نحوه محاسبه سود',
					// 	align: 'center',
					// 	sortable: true,
					// 	value: 'loanProfitType',
					// }, {
					// 	text: 'درصد دیرکرد',
					// 	align: 'center',
					// 	sortable: true,
					// 	value: 'delayPercent',
					// }, {
					// 	text: 'درصد زودکرد',
					// 	align: 'center',
					// 	sortable: true,
					// 	value: 'earlyPercent',
					// },
					// {
					// 	text: 'اسپانسری',
					// 	align: 'center',
					// 	sortable: true,
					// 	value: 'isSponsored',
					// }, 
					{
						text: 'سایر تنظیمات',
						align: 'center',
						sortable: true,
						value: 'isSmsActive',
						width: 215,
					},
					{
						text: 'عملیات',
						align: 'center',
						sortable: false,
						width: 150,
						value: 'operations',
					},
				],
				loans: [],
				imageUploaderOptions: {
					image: {
						width: '100%'
					}
				},
				editor: ClassicEditor,
				editorConfig: {
					contentsLangDirection: 'rtl',
					language: 'fa',
					toolbar: {
						shouldNotGroupWhenFull: true
					}
				},
				loanCosts: [],
				tags: [],
				allowedInstallments: {
					selectedRadio: 0,
					splitedInstallments: [],
					max: ''
				}
			}
		},
		computed: {
			...get('siteConfig', [
				'showSponsoreCheck'
			]),
			isNew() {
				return this.localData.id === emptyId
			}
		},
		mounted() {
			this.loadData()
			this.loadTags()
		},
		methods: {
			loadTags() {
				api.get('admin/Tag/List/0', null)
					.then(
						response => {
							this.tags = response
						})
					.catch(err => {
						toast.error('خطا در دریافت لیست برچسب ها از سرور' + err.message)
					})
					.finally(x => {
					})
			},
			loadData() {
				this.loading = true
				api.get('admin/loan/list', null)
					.then(
						response => {
							this.loans = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			add() {
				api.get('admin/loan/get/' + emptyId, null)
					.then(
						response => {
							this.localData = response
							this.localData.profitPercent = ''
							this.localData.maxMonthGap = ''
							this.localData.maxAmount = ''
							this.allowedInstallments.selectedRadio = 0
							this.allowedInstallments.max = ''
							this.allowedInstallments.splitedInstallments = []
							this.dialog = true
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			edit(item) {
				this.selectedItem = item
				api.get('admin/loan/get/' + item.id, null)
					.then(
						response => {
							this.localData = response
							this.loanCosts = this.localData.costsJson ? JSON.parse(this.localData.costsJson) : []
							if (!this.localData.allowedInstallments) {
								this.allowedInstallments.selectedRadio = 0
								this.allowedInstallments.max = ''
								this.allowedInstallments.splitedInstallments = []
							}
							else if (this.localData.allowedInstallments.includes('[')) {
								this.allowedInstallments.selectedRadio = 2
								this.allowedInstallments.max = ''
								this.allowedInstallments.splitedInstallments = JSON.parse(this.localData.allowedInstallments || '[]').filter(x => x).map(x => {
									x.status = ''
									return x
								})
							}
							else {
								this.allowedInstallments.selectedRadio = 1
								this.allowedInstallments.max = this.localData.allowedInstallments
								this.allowedInstallments.splitedInstallments = []
							}
							this.localData.maxMonthGap = this.localData.maxMonthGap === 0 ? '' : this.localData.maxMonthGap
							this.localData.maxAmount = this.localData.maxAmount === 0 ? '' : this.localData.maxAmount
							this.dialog = true
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			addCost() {
				this.loanCosts.push({ title: '', month: '', amount: 0 })
			},
			removeCost(index) {
				this.loanCosts.splice(index, 1)
			},
			submit() {
				if (!this.$refs.form1.validate()) {
					this.activeTab = 0
					return
				}
				if (this.$refs.form2 && !this.$refs.form2.validate()) {
					this.activeTab = 1
					return
				}
				let allowedInstallments = ' '
				if (this.allowedInstallments.selectedRadio === 1) {
					allowedInstallments = this.allowedInstallments.max
				} else if (this.allowedInstallments.selectedRadio === 2) {
					if (this.allowedInstallments.splitedInstallments.length)
						this.allowedInstallments.splitedInstallments = this.allowedInstallments.splitedInstallments.map(x => {
							x.value = Number(x.value)
							return x
						})
					allowedInstallments = JSON.stringify(this.allowedInstallments.splitedInstallments)
				}
				this.localData.costsJson = JSON.stringify(this.loanCosts)
				this.localData.includePlan = !!this.localData.includePlan
				this.localData.allowedInstallments = allowedInstallments
				const formData = new FormData()
				var fileUploader = this.$refs['imageUploader']
				if (fileUploader && fileUploader.hasFile()) {
					formData.append('file', fileUploader.getFile())
				}
				for (var key in this.localData) {
					if (key === 'disableText' && this.localData[key] == null)
						this.localData[key] = ''
					if (key === 'tags') {
						for (let i = 0; i < this.localData.tags?.length; i++) {
							formData.append(`tags[${i}][id]`, this.localData.tags[i].id)
						}
					} else {
						formData.append(key, this.localData[key])
					}
				}
				this.submitLoading = true
				api.post('admin/loan/' + (this.localData.id === emptyId ? 'create' : 'edit'), formData, { contentType: 'multipart/form-data' })
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.loadData()
						this.dialog = false
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(err => {
						this.submitLoading = false
					})
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/loan/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			viewImage(img) {
				this.overlay = true
				this.overlayImgSrc = img
			},
			changeIncludePlanSwitch(val) {
				if (val)
					this.localData.planTitle = this.localData.title
			},
			onEditorReady(editor) {
				editor.ui.getEditableElement().parentElement.insertBefore(
					editor.ui.view.toolbar.element,
					editor.ui.getEditableElement()
				)
			},
			removeAllowedInstallmentsItem(index) {
				this.allowedInstallments.splitedInstallments.splice(index, 1)
			},
			addAllowedInstallmentsItem() {
				this.allowedInstallments.splitedInstallments.push({ value: '', max: 0, status: 'new', key: Date.now() })
			}
		},
	}
</script>
<style scoped>
	.mobile {
		color: #333;
	}

	@media screen and (max-width: 768px) {
		.mobile table.v-table tr {
			max-width: 100%;
			position: relative;
			display: block;
		}

		.mobile table.v-table tr:nth-child(odd) {
			border-left: 6px solid deeppink;
		}

		.mobile table.v-table tr:nth-child(even) {
			border-left: 6px solid cyan;
		}

		.mobile table.v-table tr td {
			display: flex;
			width: 100%;
			border-bottom: 1px solid #f5f5f5;
			height: auto;
			padding: 10px;
		}

		.mobile table.v-table tr td ul li:before {
			content: attr(data-label);
			padding-right: 0.5em;
			text-align: left;
			display: block;
			color: #999;
		}

		.v-datatable__actions__select {
			width: 50%;
			margin: 0px;
			justify-content: flex-start;
		}

		.mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
			background: transparent;
		}
	}

	.flex-content {
		padding: 0;
		margin: 0;
		list-style: none;
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}

	.flex-item {
		padding: 5px;
		width: 50%;
		height: 40px;
		font-weight: bold;
	}
</style>
